export default __webpack_public_path__ + "static/homelogo-a2672123b01434f481d59642141f06ed.png";